import { Flex, Text, type TextProps } from '@mantine/core'

import { type CoreCustomer } from '@flecto/types'

export type TextCustomerContactsProps = TextProps & {
  customer: CoreCustomer
}

export function TextCustomerContacts({
  customer,
  ...props
}: TextCustomerContactsProps) {
  return (
    <Flex align='center' gap='xs' wrap='wrap'>
      <Text {...props}>{customer.email ?? ''}</Text>
      {customer.email && customer.phone_number ? (
        <Text size='xs' c='dimmed'>
          •
        </Text>
      ) : null}
      <Text
        {...props}
      >{`${customer.meta?.phone_number_country_code ?? ''} ${customer.phone_number ?? ''}`}</Text>
    </Flex>
  )
}
